// extracted by mini-css-extract-plugin
module.exports =  {"BtnModal":"BtnModal__7wtSM"};